
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/topic/[topic]",
      function () {
        return require("private-next-pages/[region]/topic/[topic]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/topic/[topic]"])
      });
    }
  